import { memo } from "react";

const ActionPlusSign = () => (
  <svg viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.66675 4V12" stroke="currentColor" strokeWidth="1.3303" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M4.66675 8L12.667 8"
      stroke="currentColor"
      strokeWidth="1.3303"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default memo(ActionPlusSign);
